import React, { Fragment, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import BackComponent from '../../../../components/BackComponent'
import Label from '../../../helpers/Label'
import Card from '../../../helpers/Card'
import Input from '../../../helpers/Input'
import LinkButton from '../../../helpers/LinkButton'
import Loader from '../../../Common/Loader'
import Validation from '../../../helpers/Validation'
import { ArrowCircleLeft2 } from 'iconsax-react'
import CancelButton from '../../../helpers/CancelButton'
import SaveButton from '../../../helpers/SaveButton'
import { ClearInfo } from '../../../../Encapsulation/Utils'
import flasher from '@flasher/flasher'
import { GetGAAProject } from '../../../../Encapsulation/HotelDomainEntities/Hotel Master/GAAProject'
import { GetGAAProjectSpaceTypePlannedDevice, SaveGAAProjectSpaceTypePlannedDevice } from '../../../../Encapsulation/HotelDomainEntities/Hotel Master/GAAProjectSpaceTypePlannedDevice'
import { GetProjectSpaceType } from '../../../../Encapsulation/HotelDomainEntities/Hotel Master/GAAProjectSpaceType'
import { GetProjectSpaceTypeArea } from '../../../../Encapsulation/HotelDomainEntities/Hotel Master/GAAProjectSpaceGroupTypeArea'
import { GetGAAProductModesMasterList } from '../../../../Encapsulation/GladianceDomainEntities/GAAProductModeMaster'
import CustomSelect from '../../../helpers/CustomSelect'
import Option from '../../../helpers/Option'

function GAAProjectSpaceTypePlannedDeviceAddEdit({Rights}) {
console.log('Rights :', Rights);
  let formMode = "New";
  let { id } = useParams();
  {
    if (id) {
      document.title = "Hotel - Edit Planned Device";
      formMode = "Edit";
    } else {
      document.title = "Hotel - Add Plan Device";
    }
  }
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const Navigation = useNavigate();
  const Location = useLocation()
  const [formInfo, setFormInfo] = useState({});
  const [GAAProductList, setGAAProductList] = useState([]);

  const handleChange = (e) => {
    setFormInfo((formInfo) => ({
      ...formInfo,
      [e.target.name]: e.target.value,
    }));
  };

  // Save All Data To Server //
  const handleSubmit = async (e) => {
    e.preventDefault();
    let result = await SaveGAAProjectSpaceTypePlannedDevice(id, formInfo, []);
    if (result.Successful == false) {
      flasher.warning(result.Message);
    } else {
      flasher.success("Data Added Successfully");
      if (formMode == "Edit") {
        Navigation("/gaa-project-space-type-planned-device");
      } else {
        setFormInfo(ClearInfo(formInfo));
        fetchProjectSpaceTypeandArea();                   // Save ProjectRef 
      }
      console.log("result :", result);
    }
  };

  // Fetch project Space Type AND Area Using Location State //
  const fetchProjectSpaceTypeandArea = async () => {
    let Project = await GetGAAProject(Location.state.GAAProjectRef);
    setFormInfo(formInfo => ({
      ...formInfo,
      GAAProjectRef: Project.Ref,
      GAAProjectName: Project.Name
    }))
    let SpaceType = await GetProjectSpaceType(Location.state.GAAProjectSpaceTypeRef);
    setFormInfo(formInfo => ({
      ...formInfo,
      GAAProjectSpaceTypeRef: SpaceType.Ref,
      GAAProjectSpaceTypeName: SpaceType.Name,
    }))

    let SpaceTypeArea = '';
    if (Location.state.GAAProjectSpaceTypeAreaRef) {
      SpaceTypeArea = await GetProjectSpaceTypeArea(Location.state.GAAProjectSpaceTypeAreaRef);
    }
    if (SpaceTypeArea) {
      setFormInfo(formInfo => ({
        ...formInfo,
        GAAProjectSpaceTypeAreaRef: SpaceTypeArea.Ref,
        GAAProjectSpaceTypeAreaName: SpaceTypeArea.Name
      }));
    } else {
      setFormInfo(formInfo => ({
        ...formInfo,
        GAAProjectSpaceTypeAreaRef: 0,
        GAAProjectSpaceTypeAreaName: '-'
      }));
    }
  };

  // Fetch Project List For Dropdown //
  const fetchProductList = async () => {
    setGAAProductList(await GetGAAProductModesMasterList());
  };

  const fetchProjectSpaceTypePlannedDevice = async () => {
    setFormInfo(await GetGAAProjectSpaceTypePlannedDevice(id))
  }

  // Fetch project Details Using Location State //
  useEffect(() => {
    if (Location.state) {
      fetchProjectSpaceTypeandArea();
    }
    if (id) {
      fetchProjectSpaceTypePlannedDevice();
    }
    fetchProductList()
  }, []);

  return (
    <Fragment>
      {loader ? (
        <Loader />
      ) : (
        <BackComponent
          title={id ? "Edit Planned Device" : "Add Plan Device"}
          button={
            <LinkButton to={"/gaa-project-space-type-planned-device"}>
              <ArrowCircleLeft2
                variant="Bold"
                className="w-5 h-5 text-default-color"
              />
            </LinkButton>
          }
        >
          <div className="flex items-center justify-center">
            <Card className={"w-full p-6"}>
              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                  <div>
                    <Label htmlFor={"GAAProjectName"} labelText={"Project Name"} />
                    {formInfo.GAAProjectRef && (<Input
                      id={"GAAProjectName"}
                      type={"text"}
                      name={"GAAProjectName"}
                      value={formInfo.GAAProjectName}
                      required={true}
                      readOnly={true}
                    />
                    )}
                  </div>
                  <div>
                    <Label htmlFor={"GAAProjectSpaceTypeName"} labelText={"Space Type"} />
                    {formInfo.GAAProjectSpaceTypeRef && (<Input
                      id={"GAAProjectSpaceTypeName"}
                      type={"text"}
                      name={"GAAProjectSpaceTypeName"}
                      value={formInfo.GAAProjectSpaceTypeName}
                      required={true}
                      readOnly={true}
                    />
                    )}
                  </div>
                  <div>
                    <Label htmlFor={"GAAProjectSpaceTypeAreaName"} labelText={"Area"} />
                    {formInfo.GAAProjectSpaceTypeAreaRef == 0 ? (<Input
                      id={"GAAProjectSpaceTypeAreaName"}
                      type={"text"}
                      name={"GAAProjectSpaceTypeAreaName"}
                      value={formInfo.GAAProjectSpaceTypeAreaName}
                      required={true}
                      readOnly={true}
                    />
                    ) : (<Input
                      id={"GAAProjectSpaceTypeAreaName"}
                      type={"text"}
                      name={"GAAProjectSpaceTypeAreaName"}
                      value={formInfo.GAAProjectSpaceTypeAreaName}
                      required={true}
                      readOnly={true}
                    />
                    )}
                  </div>
                  <div>
                    <Label htmlFor={"Name"} labelText={"Name"} />
                    <Input
                      id={"Name"}
                      type={"text"}
                      name={"Name"}
                      value={formInfo.Name}
                      inputFocus={true}
                      onChange={handleChange}
                      required={true}
                      readOnly={!Rights.Edit}

                    />
                    <Validation error={errors.Name} />
                  </div>
                  <div>
                    <Label htmlFor={"GAAProductRef"} labelText={"Product"} />
                    <CustomSelect id={'GAAProductRef'} name={'GAAProductRef'} value={formInfo.GAAProductRef} onChange={handleChange}>
                      <Option value={''}>--- Select Product ---</Option>
                      {GAAProductList && GAAProductList.map((data, id) => {
                        return (
                          <Fragment key={id}>
                            <Option
                              value={data.Ref}
                            >
                              {data.Name}
                            </Option>
                          </Fragment>
                        );
                      })}
                    </CustomSelect>
                  </div>
                </div>
                <div className="flex gap-8 justify-center mt-6">
                  <CancelButton to={"/gaa-project-space-type-planned-device"} />
                  {
                    Rights.Edit && <SaveButton text="Save" />
                  }                </div>
              </form>
            </Card>
          </div>
        </BackComponent>
      )}
    </Fragment>
  );
}
export default GAAProjectSpaceTypePlannedDeviceAddEdit;
